import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const EczemaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Eczema</h1>
        <section className="mb-8">
          <p>Eczema is a chronic skin condition characterized by dry, itchy, and inflamed skin. It can be triggered by various factors including allergies, stress, and environmental irritants. Our natural therapies focus on soothing inflammation, repairing the skin barrier, and preventing flare-ups.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Genetic predisposition</li>
            <li>Environmental triggers</li>
            <li>Allergies</li>
            <li>Stress</li>
            <li>Dry skin</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Dry, itchy skin</li>
            <li>Red, inflamed patches</li>
            <li>Rough, scaly skin</li>
            <li>Oozing or crusting</li>
            <li>Thickened skin in chronic cases</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use soothing herbs, natural moisturizers, and gentle therapies to calm inflammation, repair the skin barrier, and prevent flare-ups. Each treatment plan is personalized to address your specific triggers and symptoms.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces inflammation and itching</li>
            <li>Repairs skin barrier</li>
            <li>No harsh chemicals</li>
            <li>Long-term skin health</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Use gentle, natural skincare products</li>
            <li>Maintain proper skin hydration</li>
            <li>Identify and avoid triggers</li>
            <li>Manage stress levels</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure eczema?</strong>
            <p>A: While eczema may not be completely curable, our treatments can effectively manage symptoms and prevent flare-ups.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for children?</strong>
            <p>A: Yes, our natural remedies are gentle and safe for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice relief within a few weeks of starting treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from eczema—book your natural skin care consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default EczemaPage; 